export default [
  {
    id: 'afe35cad-a63a-4e8d-84d3-ca584d16ba4a',
    type: 'content',
    advisoryContentName: 'book-an-appointment-with-an-advisor',
    advisorySegmentName: 'callrequest',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'da-dk-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Vi hjælper dig'
          ],
          paragraphs: [
            'Få personlig rådgivning, når det passer dig bedst. Så hjælper vi dig med at blive korrekt forsikret - hverken for meget eller for lidt.'
          ],
          actions: [
            {
              text: 'Bestil et opkald',
              target: '_blank',
              className: ' ',
              url: 'https://callback.radix.if.dk/web/callback/CB.aspx?CBID=87cb1936-4c8f-4961-b01f-a4803e26d157&itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips3_book-a-call',
              loadView: null,
              actionDescription: 'book-a-call',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/if-service-personnel.png`,
              alt: 'To personer, der hjælper med råd'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '816eb6b1-14a0-4921-a088-ae58d67b5899',
    type: 'content',
    advisoryContentName: 'share-your-insurance-information',
    advisorySegmentName: 'createfamilyconnection',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'da-dk-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Del Mine sider'
          ],
          paragraphs: [
            'Ønsker du at dele Mine sider med din ægtefælle eller samlever? Så kan du gøre det under "Min Profil".'
          ],
          actions: [
            {
              text: 'Gå til Min profil',
              target: null,
              className: ' ',
              url: 'https://minesider.if.dk/min-profil?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips2_go-to-my-profile',
              loadView: null,
              actionDescription: 'go-to-my-profile',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/office-supplies.png`,
              alt: 'Kontorudstyr'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: 'b85565af-30b0-4332-95f2-6fb6e9116e2a',
    type: 'content',
    advisoryContentName: 'frequently-asked-questions',
    advisorySegmentName: 'faq',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'da-dk-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Spørgsmål og svar'
          ],
          paragraphs: [
            'Har du spørgsmål til dine forsikringer? Du kan finde mange spørgsmål og svar på vores hjemmeside.'
          ],
          actions: [
            {
              text: 'Spørgsmål og svar',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.dk/privat/kontakt/selvbetjening/faq?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips1_questions-and-answers',
              loadView: null,
              actionDescription: 'questions-and-answers',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/mini-house-pen-case.png`,
              alt: 'Penalhuse, der ligner små huse'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '5f91c13a-9a27-41f8-a852-54020d0df03c',
    type: 'content',
    advisoryContentName: 'check-your-payout-bank-account-number',
    advisorySegmentName: 'checkcustomerbankaccount',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'fi-fi-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Tilinumero ajantasalle'
          ],
          paragraphs: [
            'Tarkista, että meillä on ajantasainen tilinumero. Näin saat mahdolliset maksujen palautukset aina oikealle tilille.'
          ],
          actions: [
            {
              text: 'Päivitä tilinumero',
              target: null,
              className: ' ',
              url: 'https://omatsivut.if.fi/asiakastiedot?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips1_update-account-number',
              loadView: null,
              actionDescription: 'update-account-number',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/creditcard.png`,
              alt: 'Lompakko luottokortilla'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '8e68db74-0da8-4086-a5bd-91006a0586f9',
    type: 'content',
    advisoryContentName: 'check-your-customer-contact-details',
    advisorySegmentName: 'customercontactdetails',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'fi-fi-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Yhteystiedot ajantasalle'
          ],
          paragraphs: [
            'Tarkista, että asiakastietosi ovat ajantasalla. Näin saat aina ajantasaista tietoa vakuutuksistasi.'
          ],
          actions: [
            {
              text: 'Päivitä tietosi',
              target: null,
              className: ' ',
              url: 'https://omatsivut.if.fi/asiakastiedot?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips3_update-your-information',
              loadView: null,
              actionDescription: 'update-your-information',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/if-service-personnel.png`,
              alt: 'Kaksi ihmistä, jotka auttavat neuvoja'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '43047170-9e64-4d44-a9f7-bc04f1397f3a',
    type: 'content',
    advisoryContentName: 'frequently-asked-questions',
    advisorySegmentName: 'faq',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'fi-fi-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Usein kysytyt kysymykset'
          ],
          paragraphs: [
            'Mietityttääkö jokin laskutukseen, korvauksiin tai vakuutuksiin liittyvä asia? Katso, löytyisikö kysymykseesi vastaus sivuiltamme.'
          ],
          actions: [
            {
              text: 'Usein kysytyt kysymykset',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.fi/henkiloasiakkaat/asiakaspalvelu/usein-kysyttya?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips2_frequently-asked-questions',
              loadView: null,
              actionDescription: 'frequently-asked-questions',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/mini-house-pen-case.png`,
              alt: 'Lyijykynäkotelot, jotka näyttävät pieniltä taloilta'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '94bd9bfa-6875-4245-b666-afec181fb3ee',
    type: 'content',
    advisoryContentName: 'check-your-customer-contact-details',
    advisorySegmentName: 'customercontactdetails',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'nb-no-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Kontaktinformasjon'
          ],
          paragraphs: [
            'Er din kontaktinformasjon oppdatert? Her kan du endre e-postadresse og mobilnummer.'
          ],
          actions: [
            {
              text: 'Til min profil',
              target: null,
              className: ' ',
              url: 'https://minesider.if.no/min-profil?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips2_to-my-profile',
              loadView: null,
              actionDescription: 'to-my-profile',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/creditcard.png`,
              alt: 'Lommebok med kredittkort'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: 'bccf9883-07f2-4cf6-8d6e-1fce159a41f3',
    type: 'content',
    advisoryContentName: 'find-answers-yourself-or-contact-customer-service',
    advisorySegmentName: 'customerservice',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'nb-no-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Kundeservice'
          ],
          paragraphs: [
            'Vi hjelper deg uansett hva du lurer på. Finn svar selv eller kontakt kundeservice.'
          ],
          actions: [
            {
              text: 'Til kundeservice',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.no/privat/kundeservice?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips3_to-customer-service',
              loadView: null,
              actionDescription: 'to-customer-service',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/if-service-personnel.png`,
              alt: 'To personer som hjelper med råd'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '518d832f-b083-4ec0-a66e-63b74697b8e8',
    type: 'content',
    advisoryContentName: 'find-answers-to-frequently-asked-questions',
    advisorySegmentName: 'faq',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'nb-no-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Ofte stilte spørsmål'
          ],
          paragraphs: [
            'Her finner du svar på de vanligste spørsmålene rundt våre forsikringer. Og litt til.'
          ],
          actions: [
            {
              text: 'Les ofte stilte spørsmål',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.no/privat/kundeservice/ofte-stilte-sporsmal?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips1_read-faq',
              loadView: null,
              actionDescription: 'read-faq',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/mini-house-pen-case.png`,
              alt: 'Pennal som ser ut som små hus'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '764ec802-084f-4d53-928e-419dd919aef4',
    type: 'content',
    advisoryContentName: 'check-your-payout-bank-account-number',
    advisorySegmentName: 'checkcustomerbankaccount',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-fi-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Uppdatera ditt kontonummer'
          ],
          paragraphs: [
            'Kontrollera att vi har ditt aktuella kontonummer. På så sätt får du alltid eventuella återbetalningar till rätt konto.'
          ],
          actions: [
            {
              text: 'Till Min profil',
              target: null,
              className: ' ',
              url: 'https://minasidor.if.fi/min-profil?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips3_to-my-profile',
              loadView: null,
              actionDescription: 'to-my-profile',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/creditcard.png`,
              alt: 'Plånbok med kreditkort'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: 'dcfeaf63-7671-4d60-9bcf-c102745edd75',
    type: 'content',
    advisoryContentName: 'check-your-customer-contact-details',
    advisorySegmentName: 'customercontactdetails',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-fi-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Uppdatera dina kontaktuppgifter'
          ],
          paragraphs: [
            'Kontrollera dina kontaktuppgifter så du inte missar information från oss.'
          ],
          actions: [
            {
              text: 'Till Min profil',
              target: null,
              className: ' ',
              url: 'https://minasidor.if.fi/min-profil?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips2_to-my-profile',
              loadView: null,
              actionDescription: 'to-my-profile',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/if-service-personnel.png`,
              alt: 'Två personer som hjälper med rådgivning'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '759c3cfc-5b77-4fc2-b4fc-477a2033709d',
    type: 'content',
    advisoryContentName: 'frequently-asked-questions',
    advisorySegmentName: 'faq',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-fi-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Frågor och svar'
          ],
          paragraphs: [
            'Har du frågor angående försäkringar, skador eller fakturering? Svaret kan finnas bland Vanliga frågor på våra sidor.'
          ],
          actions: [
            {
              text: 'Vanliga frågor',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.fi/sv/privat/kundservice/vanliga-fragor?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips1_faq',
              loadView: null,
              actionDescription: 'faq',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/mini-house-pen-case.png`,
              alt: 'Pennfodral som ser ut som små hus'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '44e78791-0970-41e1-870e-ddb6701a1c96',
    type: 'content',
    advisoryContentName: 'check-your-customer-contact-details',
    advisorySegmentName: 'customercontactdetails',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-if',
    touchpointView: 'insurances-overview',
    template: 'smart',
    advisoryType: 'tile',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Är dina kontaktuppgifter uppdaterade?'
          ],
          paragraphs: [
            'Kontrollera gärna dina kontaktuppgifter så du inte missar information från oss.'
          ],
          actions: [
            {
              text: 'Till Min profil',
              target: null,
              idsClassName: 'if link standalone icon',
              url: 'https://minasidor.if.se/min-profil/?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tile_to-my-profile',
              loadView: null,
              actionDescription: 'to-my-profile',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: null,
          icons: [
            {
              group: 'ui',
              name: 'user'
            }
          ],
          visuals: null
        }
      }
    ]
  },
  {
    id: '211f62d5-262f-4717-ae92-64f974ec429c',
    advisoryContentName: 'call-request-volvia',
    type: 'content',
    advisorySegmentName: 'callrequest',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-volvia',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'banner',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: 'volvia',
        viewLayout: 'paragraphResponsiveImage',
        viewElements: {
          headlines: [
            'Vi bryr oss om dig och din säkerhet'
          ],
          paragraphs: [
            'För oss är din säkerhet alltid det viktigaste, både i och utanför bilen. Då vi är en del av If kan du boka tid med en av våra försäkringsrådgivare och se över hela ditt försäkringsbehov.'
          ],
          actions: [
            {
              text: 'Boka försäkringsrådgivning',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.se/privat/kundservice/guider/forsakringsbehov?utm_source=volvia&utm_medium=link&utm_campaign=advisory-mypages',
              loadView: null,
              actionDescription: 'book-call-request',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/person-sitting-in-rocking-chair.jpg`,
              alt: 'Person som använder en läsplatta'
            },
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/chevron-right.svg`,
              alt: 'Sparre höger'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: 'b2e89add-fad5-4acd-ad92-978ab51fcb9e',
    advisoryContentName: 'call-request-renault',
    type: 'content',
    advisorySegmentName: 'callrequest',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-renault',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'banner',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: 'renault',
        viewLayout: 'paragraphResponsiveImage',
        viewElements: {
          headlines: [
            'Vi bryr oss om dig och din säkerhet'
          ],
          paragraphs: [
            'För oss är din säkerhet alltid det viktigaste, både i och utanför bilen. Då vi är en del av If kan du boka tid med en av våra försäkringsrådgivare och se över hela ditt försäkringsbehov.'
          ],
          actions: [
            {
              text: 'Boka försäkringsrådgivning',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.se/privat/kundservice/guider/forsakringsbehov?utm_source=renault&utm_medium=link&utm_campaign=advisory-mypages',
              loadView: null,
              actionDescription: 'book-call-request',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/person-sitting-in-rocking-chair.jpg`,
              alt: 'Person som använder en läsplatta'
            },
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/chevron-right.svg`,
              alt: 'Sparre höger'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '10f2d003-12e1-42e3-b122-11fb78414454',
    advisoryContentName: 'call-request-kia',
    type: 'content',
    advisorySegmentName: 'callrequest',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-kia',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'banner',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: 'kia',
        viewLayout: 'paragraphResponsiveImage',
        viewElements: {
          headlines: [
            'Vi bryr oss om dig och din säkerhet'
          ],
          paragraphs: [
            'För oss är din säkerhet alltid det viktigaste, både i och utanför bilen. Då vi är en del av If kan du boka tid med en av våra försäkringsrådgivare och se över hela ditt försäkringsbehov.'
          ],
          actions: [
            {
              text: 'Boka försäkringsrådgivning',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.se/privat/kundservice/guider/forsakringsbehov?utm_source=kia&utm_medium=link&utm_campaign=advisory-mypages',
              loadView: null,
              actionDescription: 'book-call-request',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/person-sitting-in-rocking-chair.jpg`,
              alt: 'Person som använder en läsplatta'
            },
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/chevron-right.svg`,
              alt: 'Sparre höger'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '1add53ff-0785-42d0-93c0-429888d03543',
    type: 'content',
    advisoryContentName: 'insurance-needs-book-a-consultation',
    advisorySegmentName: 'callrequest',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Boka telefonrådgivning'
          ],
          paragraphs: [
            'Boka rådgivning så går vi tillsammans igenom ditt försäkringsbehov. Det tar bara cirka 15 minuter.'
          ],
          actions: [
            {
              text: 'Boka rådgivning',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.se/privat/kundservice/guider/forsakringsbehov?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips3_book-consultation',
              loadView: null,
              actionDescription: 'book-consultation',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/if-service-personnel.png`,
              alt: 'Två personer som hjälper med rådgivning'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: '873a7e01-7ac5-4041-8060-33b008585623',
    type: 'content',
    advisoryContentName: 'check-your-customer-contact-details',
    advisorySegmentName: 'customercontactdetails',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Kontaktuppgifter'
          ],
          paragraphs: [
            'Kontrollera gärna dina kontaktuppgifter så du inte missar information från oss.'
          ],
          actions: [
            {
              text: 'Till min profil',
              target: null,
              className: ' ',
              url: 'https://minasidor.if.se/min-profil/?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips2_to-my-profile',
              loadView: null,
              actionDescription: 'to-my-profile',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/mini-house-pen-case.png`,
              alt: 'Pennfodral som ser ut som små hus'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  },
  {
    id: 'aa68b006-8aa0-491b-91eb-77fb8043293d',
    type: 'content',
    advisoryContentName: 'payment-frequently-asked-questions',
    advisorySegmentName: 'faq',
    segmentNameDefaultPrefix: 'advisory-default',
    touchpointId: 'sv-se-mypages-if',
    touchpointView: 'start',
    template: 'simple',
    advisoryType: 'tips',
    initialView: 1,
    contentViews: [
      {
        contentViewId: 1,
        viewTheme: undefined,
        viewLayout: 'paragraph',
        viewElements: {
          headlines: [
            'Frågor om betalning'
          ],
          paragraphs: [
            'Har du frågor om betalning och våra olika betalningssätt? Här hittar du vanliga frågor och svar om betalning.'
          ],
          actions: [
            {
              text: 'Betalningsfrågor',
              target: '_blank',
              className: ' ',
              url: 'https://www.if.se/privat/kundservice/guider/betalningsguide?itm_source=mypages&itm_medium=recommendation&itm_campaign=advisory_tips1_payment-faq',
              loadView: null,
              actionDescription: 'payment-faq',
              actionCategory: 'other',
              callbackPath: null
            }
          ],
          media: [
            {
              url: `${import.meta.env.VITE_BASE_PATH}/assets/creditcard.png`,
              alt: 'Plånbok med kreditkort'
            }
          ],
          icons: null,
          visuals: null
        }
      }
    ]
  }
];
